enum Tabs {
  General = 'general',
  Members = 'members',
  Billing = 'billing',
  Activity = 'activity_feed',
  ApiKeys = 'api_keys',
}

type MatchParams = {
  tabId?: Tabs;
};

export { Tabs, MatchParams };
